import {
  AdjustLogo,
  ImageSelectionList,
  LogoPlacement,
  TermsAndConditions,
} from "../components/step";

export const STEPS_COMPONENT = {
  step1: TermsAndConditions,
  step2: LogoPlacement,
  step3: ImageSelectionList,
  step4: AdjustLogo,
};
